<!--
  상상코칭 로그인 진입 컴포넌트 (웹) — Vue 2 / Options API
  라우트: /sangsang/login?key=<uuid>

  흐름:
    1) 쿼리에서 key(uuid) 추출
    2) API 서버에 GET /sangsang/{game|lms}/accept/process/:key  → { token, infoConfirmed, payPlan }
       (key 는 단일 사용: 서버가 GETDEL — 새로고침 시 재사용 불가하니 주의)
    3) token 저장 → 로그인 처리
    4) infoConfirmed=false (게임) → 학년/출판사 설정 화면, 아니면 메인으로

  배포처별 설정:
    - 게임 프론트(ARGONG_GAME_FRONT_URL) : LOGIN_TYPE='game'
    - LMS 프론트(ARGONG_LMS_FRONT_URL)   : LOGIN_TYPE='lms'
    - API 베이스: .env 의 VUE_APP_CONNECT
-->
<template>
  <div class="ss-login">
    <div v-if="state === 'loading'" class="box">
      <div class="spinner" />
      <p>로그인 처리 중…</p>
    </div>
    <div v-else-if="state === 'error'" class="box">
      <p class="err">{{ errorMsg }}</p>
      <button class="retry" @click="goHome">처음으로</button>
    </div>
  </div>
</template>

<script>
import { nonSaveCookie } from "@/store/cookie";

// ── 설정 ──────────────────────────────────────────────
const LOGIN_TYPE = "game"; // ← LMS 프론트에서는 'lms' 로
const API_BASE = process.env.VUE_APP_CONNECT;

const HOME_ROUTE = "/"; // 로그인 후 기본 이동
const INFO_SETUP_ROUTE = "/onboarding"; // 학년/출판사 미확정(infoConfirmed=false) 시
// ─────────────────────────────────────────────────────

export default {
  name: "SangsangLogin",

  data() {
    return {
      state: "loading", // loading | error
      errorMsg: "",
    };
  },

  async mounted() {
    const key = String(this.getKey());
    if (!key) {
      this.state = "error";
      this.errorMsg = "잘못된 접근입니다. (key 없음)";
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE}/sangsang/${LOGIN_TYPE}/accept/process/${encodeURIComponent(
          key
        )}`
      );
      const json = await res.json();
      const data = json && json.data;

      if (!data || !data.token) {
        this.state = "error";
        this.errorMsg =
          (data && data.message) || "만료되었거나 유효하지 않은 키입니다.";
        return;
      }

      // ── 토큰 저장 (앱 컨벤션에 맞게 조정) ──
      // 1) localStorage (프론트에서 Authorization 헤더로 사용 시)
      //localStorage.setItem("argong_token", data.token);
      sessionStorage.setItem("info2", data.token);
      nonSaveCookie("info2", data.token);
      nonSaveCookie("sangsang", "true");

      // setTimeout(() => {
      //   this.$router.push({ path: "/" });
      // }, 500);
      //if (data.payPlan) localStorage.setItem("argong_payPlan", data.payPlan);
      // 2) 쿠키 'user' (서버 jwt.strategy 가 쿠키에서 읽는 경우)
      // document.cookie = `info=${data.token}; path=/; max-age=${
      //   60 * 60 * 24 * 30
      // }`;

      // ── 분기: 학년/출판사 초기 확정 필요 여부 ──
      if (LOGIN_TYPE === "game" && data.infoConfirmed === false) {
        // window.location.href = INFO_SETUP_ROUTE;
        this.state = "error";
        this.errorMsg =
          "학년과 출판사가 정해지지 않았어요. 선생님께 문의해주세요.";
      } else {
        //window.location.href = HOME_ROUTE;
        setTimeout(() => {
          this.$router.push({ path: "/" });
        }, 500);
      }
    } catch (e) {
      this.state = "error";
      this.errorMsg = "로그인 처리 중 오류가 발생했어요. 다시 시도해 주세요.";
    }
  },

  methods: {
    getKey() {
      // 라우터 쿼리 우선, 없으면 URL 직접 파싱
      return (
        this.$route.query.key ||
        new URLSearchParams(window.location.search).get("key") ||
        ""
      );
    },

    goHome() {
      this.$router.replace(HOME_ROUTE);
    },
  },
};
</script>

<style scoped>
.ss-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fb;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.box {
  text-align: center;
}
.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #d6e0f5;
  border-top-color: #3b6ef5;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.err {
  color: #d23;
  font-size: 20px;
}
.retry {
  margin-top: 12px;
  padding: 9px 16px;
  background: #3b6ef5;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}
</style>